import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@ranch/shared/styles/theme.css";
import "@ranch/shared/styles/appearance.css";
import "./styles/app.css";
import { setUnauthorizedHandler } from "./lib/api";
import { registerAppShell } from "./lib/install";
import { queryClient } from "./lib/query";
import { languageReady } from "./lib/i18n";
import { App } from "./App";

setUnauthorizedHandler(() => { void queryClient.invalidateQueries({ queryKey: ["/me"] }); });
registerAppShell();

void languageReady().finally(() => createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>));
